import { Clock } from '../domain/ports/clock';

// System clock adapter that wraps Date constructor
export const systemClock: Clock = {
  now(): Date {
    return new Date();
  },
};

